import { ArrowUpRight } from "lucide-react";
import { Reveal, ChapterHeading } from "./Reveal";
import PayButtons from "./PayButtons";
import { CONSULTATIONS, waLink } from "@/config";

const Consultations = () => (
  <section
    id="danismanlik"
    data-testid="consultation-section"
    className="relative z-10 py-24 sm:py-32 bg-navy-800/40"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <ChapterHeading
        chapter={CONSULTATIONS.chapter}
        label={CONSULTATIONS.label}
        title={CONSULTATIONS.title}
        subtext={CONSULTATIONS.subtext}
      />

      <div className={`mt-14 grid gap-6 ${CONSULTATIONS.services.length === 1 ? "max-w-xl mx-auto" : "sm:grid-cols-2"}`}>
        {CONSULTATIONS.services.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.1} className="h-full">
            <article
              data-testid={s.testId}
              className="card-glow flex h-full flex-col rounded-2xl border border-gold/20 bg-navy/80 backdrop-blur-sm p-7 sm:p-9"
            >
              <div className="flex items-start justify-between gap-6">
                <h3 className="font-serif text-2xl text-cream leading-snug">{s.title}</h3>
                <span className="font-mono text-xs text-gold/60 tracking-widest shrink-0 mt-1.5">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <p className="mt-3 text-sm text-mist leading-relaxed flex-1">{s.description}</p>
              <p className="mt-4 text-xs font-mono tracking-wider text-cream/60 uppercase">
                {s.duration}
              </p>
              <div className="mt-6 flex flex-wrap items-center justify-between gap-4 border-t border-gold/15 pt-6">
                <span
                  className="font-serif text-3xl text-gold"
                  data-testid={`${s.testId}-price`}
                >
                  {s.price}
                </span>
                <a
                  href={waLink(s.waMessage)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`${s.testId}-cta`}
                  className="group inline-flex items-center gap-2 rounded-full border border-gold/50 px-6 py-3 text-sm font-semibold text-cream transition-all duration-300 hover:border-gold hover:bg-gold hover:text-ink"
                >
                  Randevu Al
                  <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </div>
              <PayButtons productId={s.id} title={s.title} testId={s.testId} />
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Consultations;
